import notificationsService from '@Share/services/notifications.service';
import { $handleError } from '@/utils';


export const NOTIFICATIONS = {
	namespaced: true,
	state: {
		notificationsPreferences: [],
		userNotifications: [],
		loading: false,
		updateLoading: false,
		hasNewNotification: false
	},
	getters: {
		GET_NOTIFICATION_PREFERENCES(state) {
			return state.notificationsPreferences;
		},
		GET_USER_NOTIFICATIONS(state) {
			return state.userNotifications.sort((a, b) => new Date(b.createDate) - new Date(a.createDate));
		},
		GET_UPDATE_LOADING(state) {
			return state.updateLoading;
		},
		GET_HAS_NEW_NOTIFICATION(state) {
			return state.hasNewNotification;
		}
	},
	mutations: {
		SET_NOTIFICATION_PREFERENCES(state, val) {
			state.notificationsPreferences = val;
		},
		SET_USER_NOTIFICATIONS(state, val) {
			state.userNotifications = val;
		},
		PUSH_USER_NOTIFICATION(state, val) {
			state.userNotifications.unshift(val)
			state.hasNewNotification = true
		},
		SET_LOADING(state, value) {
			state.loading = value;
		},
		SET_UPDATE_LOADING(state, value) {
			state.updateLoading = value;
		},
		SET_HAS_NEW_NOTIFICATION(state, value) {
			state.hasNewNotification = value;
		}
	},
	actions: {
		GET_PREFERENCES({ commit }) {
			commit('SET_LOADING', true);
			notificationsService
				.getPreferences()
				.then((res) => {
					commit('SET_NOTIFICATION_PREFERENCES', res.data);
				})
				.catch((err) => {
					$handleError(err);
				})
				.finally(() => {
					commit('SET_LOADING', false);
				});
		},
		GET_USER_NOTIFICATIONS({ commit }, data) {
			commit('SET_LOADING', true);
			notificationsService
				.getUserNotifications(data)
				.then((res) => {
					res.data.items.forEach(elem => {
						let parsedBoody = JSON.parse(elem.body)
						elem.body = parsedBoody
					})
					commit('SET_USER_NOTIFICATIONS', res.data.items);
					commit('SET_HAS_NEW_NOTIFICATION', res.data.items.some(item => item.read === false));
				})
				.catch((err) => {
					$handleError(err);
				})
				.finally(() => {
					commit('SET_LOADING', false);
				});
		},
		UPDATE_PREFERENCES({ commit }, data) {
			return new Promise((resolve, reject) => {
				commit('SET_UPDATE_LOADING', true);
				notificationsService
					.updatePreferences(data)
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						$handleError(err);
						reject(err);
					})
					.finally(() => {
						commit('SET_UPDATE_LOADING', false);
					});
			});
		},
		MARK_READ_UNREAD({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				commit('SET_UPDATE_LOADING', true);
				notificationsService
					.read(data)
					.then((res) => {
						resolve(res);
						dispatch('GET_USER_NOTIFICATIONS')
					})
					.catch((err) => {
						$handleError(err);
						reject(err);
					})
					.finally(() => {
						commit('SET_UPDATE_LOADING', false);
					});
			});
		},
		MARK_ALL_AS_READ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				commit('SET_UPDATE_LOADING', true);
				notificationsService
					.readAll()
					.then((res) => {
						resolve(res);
						dispatch('GET_USER_NOTIFICATIONS')
					})
					.catch((err) => {
						$handleError(err);
						reject(err);
					})
					.finally(() => {
						commit('SET_UPDATE_LOADING', false);
					});
			});
		},
		CLEAR_ALL({ dispatch }) {
			return new Promise((resolve, reject) => {
				notificationsService
					.clearAll()
					.then((res) => {
						resolve(res);
						dispatch('GET_USER_NOTIFICATIONS')
					})
					.catch((err) => {
						$handleError(err);
						reject(err);
					})
					.finally(() => {
					});
			});
		},
	},
};
